import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
import { Grid } from '@material-ui/core';
export const StyledContentIGPC = styled('div') `
	text-align: justify;
`;
export const StyledCarrierSectionContainerIGPC = styled('div') `
	margin-bottom: ${Magnetic.spacer08};
`;
export const StyledDivSingleUploadImageIGPC = styled(Grid, {
    shouldForwardProp: prop => !['background', 'height', 'size'].includes(prop)
}) `
	background: ${props => Magnetic[props.background]} no-repeat center;
	height: ${(props) => props.height};
	width: 100%;
	background-size: ${(props) => props.size};
	margin-bottom: ${Magnetic.spacer24};
`;
//# sourceMappingURL=IntelligentSinglePhotoUploadComponent.style.js.map